export default {
  after: (field, [target]) => `${field} 一定要在 ${target} 之后。`,
  alpha: (field) => `${field} 只能拥有字母与字符。`,
  alpha_dash: (field) => `${field} 可拥有字符如破折号或下划线。`,
  alpha_num: (field) => `${field} 只能拥有数字字符。`,
  alpha_spaces: (field) => `${field} 只能拥有字母或空格。`,
  before: (field, [target]) => `${field} 必须在 ${target} 之前。`,
  between: (field, [min, max]) => `${field} 必须最少 ${min} 或最高 ${max} 之间。`,
  confirmed: (field) => `${field} 无法通过确认。`,
  credit_card: (field) => `${field} 无效`,
  date_between: (field, [min, max]) => `${field} 一定要在 ${min} 至 ${max} 之间。`,
  date_format: (field, [format]) => `${field} 一定要以 ${format} 格式。`,
  decimal: (field, [decimals] = ['*']) => `${field} 一定要以数字或可拥有 ${decimals === '*' ? '' : decimals} 小数点。`,
  digits: (field, [length]) => `${field} 一定要以数字和整体只能拥有 ${length} 位数.`,
  dimensions: (field, [width, height]) => `${field} 只能宽 ${width} 像素和高 ${height} 像素。`,
  email: (field) => `${field} 必须是符合的格式。`,
  ext: (field) => `${field} 必须是符合的文件。`,
  image: (field) => `${field} 必须是符合的图片。`,
  in: (field) => `${field} 必须是符合的输入。`,
  ip: (field) => `${field} 必须是符合的IP地址`,
  max: (field, [length]) => `${field} 不能多于 ${length} 字母。`,
  max_value: (field, [max]) => `${field} 输入最多为 ${max} 字母。`,
  mimes: (field) => `${field} 必须是符合的文件类型。`,
  min: (field, [length]) => `${field} 需至少 ${length} 字母。`,
  min_value: (field, [min]) => `${field} 输入最少为 ${min} 字母。`,
  not_in: (field) => `${field} 必须符合输入标准。`,
  numeric: (field) => `${field} 只能拥有数字。`,
  regex: (field) => `${field} 格式不正确。`,
  required: (field) => `${field} 需要填写。`,
  size: (field, [size]) => `${field} 必须低于 ${size} KB.`,
  url: (field) => `${field} 不是符合网址`
}
